import React from "react";

import "./AccountingPeriodPicker.scss";

type AccountPeriodPickerProps = {
  onChange: (state: AccountPeriodPickerState) => void;
  years: string[];
};

export type AccountPeriodPickerState = {
  startYear: string;
  startMonth: string;
  monthCount: number;
};

export class AccountingPeriodPicker extends React.Component<
  AccountPeriodPickerProps,
  AccountPeriodPickerState
> {
  constructor(props: AccountPeriodPickerProps) {
    super(props);

    this.state = {
      startMonth: "01",
      startYear: props.years.length > 0 ? props.years[0] : "",
      monthCount: 12
    };

    this.emitOnChange();
  }
  changeStartYear = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLInputElement;
    this.setState(
      {
        startYear: target.value
      },
      this.emitOnChange
    );
  };
  changeStartMonth = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLInputElement;
    this.setState(
      {
        startMonth: target.value
      },
      () => this.emitOnChange()
    );
  };
  changeMonthCound = (event: React.SyntheticEvent): void => {
    const target = event.target as HTMLInputElement;
    this.setState(
      {
        monthCount: parseInt(target.value)
      },
      () => this.emitOnChange()
    );
  };

  emitOnChange = (): void => this.props.onChange(this.state);

  render() {
    return (
      <div>
        <select
          className="yearSelect"
          onChange={this.changeStartYear}
          value={this.state.startYear}
        >
          {this.props.years.map((year) => (
            <option value={year}>{year}</option>
          ))}
        </select>
        <select
          className="monthSelect"
          onChange={this.changeStartMonth}
          value={this.state.startMonth}
        >
          <option value="01">Januari</option>
          <option value="02">Februari</option>
          <option value="03">Mars</option>
          <option value="04">April</option>
          <option value="05">Maj</option>
          <option value="06">Juni</option>
          <option value="07">Juli</option>
          <option value="08">Augusti</option>
          <option value="09">September</option>
          <option value="10">Oktober</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>
        &nbsp;och&nbsp;
        <input
          size={3}
          type={"number"}
          onChange={this.changeMonthCound}
          value={this.state.monthCount}
        ></input>
        &nbsp;månader
      </div>
    );
  }
}
